import { render } from "./TaxNexusEditor.vue?vue&type=template&id=6db486b1&scoped=true"
import script from "./TaxNexusEditor.vue?vue&type=script&lang=js"
export * from "./TaxNexusEditor.vue?vue&type=script&lang=js"

import "./TaxNexusEditor.vue?vue&type=style&index=0&id=6db486b1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db486b1"]])

export default __exports__